<template>
  <div class="status">
    <div
      class="badge"
      :class="[ status ]"
    />
    <span>{{ statusName }}</span>
  </div>
</template>

<script lang="ts" setup>
type TProps = {
  status: string;
  statusName: string;
};
defineProps<TProps>();
</script>

<style lang="scss" scoped>
.status {
  display: flex;
  align-items: center;
  font-size: $fontsize-100;
  color: $textcolor-light;
  line-height: $fontsize-100;

  .badge {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;

    &.failed {
      background: $basecolor-error;
    }

    &.inactive {
      background: $basecolor-info;
    }

    &.draft, &.pending, &.in-progress, &.waiting {
      background: $basecolor-warning;
    }

    &.complete, &.published, &.success, &.active {
      background: $basecolor-success;
    }
  }
}
</style>
